<div class="modal-header">
    <h4 class="modal-title">PNC – Postnatal Care</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="card-body" [formGroup]="pncForm">
        <div class="row">
            <!-- Mother's Health Status -->
            <div class="col-xl-3 mb-2">
                <label>Mother's Health Status</label>
                <select class="form-control form-control-sm" formControlName="health_status_id">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of mhsList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>

            <!-- Breastfeeding -->
            <div class="col-xl-3 mb-2">
                <label>Breastfeeding</label>
                <select class="form-control form-control-sm" formControlName="breastfeeding_id">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of bfList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>

            <!-- IFA/Calcium Continued -->
            <div class="col-xl-3 mb-2">
                <label>IFA/Calcium Continued</label>
                <div>
                <input type="radio" formControlName="if_calcium_continued" [value]="true" class="ml-2 mr-2">Yes
                <input type="radio" formControlName="if_calcium_continued" [value]="false" class="ml-2 mr-2">No
              </div>
            </div>

            <!-- Family Planning Advice -->
            <div class="col-xl-3 mb-2">
                <label>Family Planning Advice</label>
                <select class="form-control form-control-sm" formControlName="family_planning_advice_id">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of fpaList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>

            <!-- Infant Immunization Status -->
            <div class="col-xl-3 mb-2">
                <label>Infant Immunization Status</label>
                <select class="form-control form-control-sm" formControlName="infant_immune_status_id">
                    <option value=null>Select</option>
                    <option *ngFor="let opt of imztnList" [value]="opt.id">{{ opt.name }}</option>
                </select>
            </div>

            <!-- <div class="col-xl-3 mb-2">
                <label>Referred To</label>
                <select class="form-control form-control-sm" formControlName="consult_refer_to_id">
                  <option value=null>Select</option>
                   <option *ngFor="let opt of referredist" [value]="opt.id">{{ opt.name }}</option>

                </select>
            </div> -->

        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" id="saveButton" class="btn btn-primary btn-sm" (click)="onSave()">Save</button>

    <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
        (click)="activeModal.close('Close click')">Close</button>
</div>